// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel/carousel.component.scss
// module id = 117
// module chunks = 0